/**
 * Teacher Assignments Service - API client for teachers to create,
 * publish, and grade assignments
 */
import api from '../utils/api';

const teacherAssignmentsService = {
  listMyAssignments: async (params) => {
    try {
      return await api.get('/api/teacher/assignments/my-assignments', { params });
    } catch (error) {
      console.error('Error fetching my assignments:', error);
      throw error;
    }
  },

  getAssignment: async (assignmentId) => {
    try {
      return await api.get(`/api/teacher/assignments/${assignmentId}`);
    } catch (error) {
      console.error('Error fetching assignment:', error);
      throw error;
    }
  },

  createAssignment: async (data) => {
    try {
      return await api.post('/api/teacher/assignments', data);
    } catch (error) {
      console.error('Error creating assignment:', error);
      throw error;
    }
  },

  updateAssignment: async (assignmentId, data) => {
    try {
      return await api.put(`/api/teacher/assignments/${assignmentId}`, data);
    } catch (error) {
      console.error('Error updating assignment:', error);
      throw error;
    }
  },

  deleteAssignment: async (assignmentId) => {
    try {
      return await api.delete(`/api/teacher/assignments/${assignmentId}`);
    } catch (error) {
      console.error('Error deleting assignment:', error);
      throw error;
    }
  },

  getStatistics: async (assignmentId) => {
    try {
      return await api.get(`/api/teacher/assignments/${assignmentId}/statistics`);
    } catch (error) {
      console.error('Error fetching assignment statistics:', error);
      throw error;
    }
  },

  publishAssignment: async (assignmentId) => {
    try {
      return await api.post(`/api/teacher/assignments/${assignmentId}/publish`);
    } catch (error) {
      console.error('Error publishing assignment:', error);
      throw error;
    }
  },

  getSubmissions: async (assignmentId) => {
    try {
      return await api.get(`/api/teacher/assignments/${assignmentId}/submissions`);
    } catch (error) {
      console.error('Error fetching submissions:', error);
      throw error;
    }
  },

  gradeSubmission: async (assignmentId, submissionId, data) => {
    try {
      return await api.post(`/api/teacher/assignments/${assignmentId}/grade/${submissionId}`, data);
    } catch (error) {
      console.error('Error grading submission:', error);
      throw error;
    }
  },

  // ---- Course Modules ----

  listCourseModules: async (params) => {
    try {
      return await api.get('/api/teacher/assignments/course-modules', { params });
    } catch (error) {
      console.error('Error fetching course modules:', error);
      throw error;
    }
  },

  createCourseModule: async (data) => {
    try {
      return await api.post('/api/teacher/assignments/course-modules', data);
    } catch (error) {
      console.error('Error creating course module:', error);
      throw error;
    }
  },

  updateCourseModule: async (moduleId, data) => {
    try {
      return await api.put(`/api/teacher/assignments/course-modules/${moduleId}`, data);
    } catch (error) {
      console.error('Error updating course module:', error);
      throw error;
    }
  },

  deleteCourseModule: async (moduleId) => {
    try {
      return await api.delete(`/api/teacher/assignments/course-modules/${moduleId}`);
    } catch (error) {
      console.error('Error deleting course module:', error);
      throw error;
    }
  },

  addModuleItem: async (moduleId, data) => {
    try {
      return await api.post(`/api/teacher/assignments/course-modules/${moduleId}/items`, data);
    } catch (error) {
      console.error('Error adding module item:', error);
      throw error;
    }
  },

  deleteModuleItem: async (itemId) => {
    try {
      return await api.delete(`/api/teacher/assignments/course-modules/items/${itemId}`);
    } catch (error) {
      console.error('Error deleting module item:', error);
      throw error;
    }
  },

  uploadModuleVideo: async (moduleId, formData) => {
    try {
      return await api.post(`/api/teacher/assignments/course-modules/${moduleId}/items/upload-video`, formData);
    } catch (error) {
      console.error('Error uploading module video:', error);
      throw error;
    }
  }
};

export default teacherAssignmentsService;
